import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { StoreProvider } from "./Store";
import { getSiteName } from "./utils/constants";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://8dbf580097ef80c32a080334f72d699f@o4507940686200832.ingest.us.sentry.io/4509999001436160",
  // defaulting to local in case variable isn't set so that we ensure local testing doesn't send errors as production issues.
  environment: process.env.REACT_APP_ENV || 'local',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // y76-backend-dev-890718153427.us-central1.run.app
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 ,// If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true
});

const selectFaviconPath = (hostname) => {
  const normalizedHost = hostname.toLowerCase();
  const isLoopback =
    normalizedHost === "localhost" ||
    normalizedHost === "::1" ||
    normalizedHost.startsWith("127.");

  if (isLoopback) {
    return "/logo-local.svg";
  }

  const isIncantorHost = normalizedHost.endsWith(".incantor.ai");

  if (isIncantorHost && normalizedHost.includes("beta")) {
    return "/logo-beta.svg";
  }

  if (isIncantorHost) {
    return "/logo.svg";
  }

  return "/logo.svg";
};

const applyFavicon = (iconPath) => {
  const publicUrl = process.env.PUBLIC_URL || "";
  const resolvedPath = `${publicUrl}${iconPath.startsWith("/") ? iconPath : `/${iconPath}`}`;
  const faviconLink =
    document.querySelector("link[rel=\"icon\"]") || document.createElement("link");
  faviconLink.rel = "icon";
  faviconLink.href = resolvedPath;
  document.head.appendChild(faviconLink);

  const appleTouchIcon =
    document.querySelector("link[rel=\"apple-touch-icon\"]") || document.createElement("link");
  appleTouchIcon.rel = "apple-touch-icon";
  appleTouchIcon.href = resolvedPath;
  document.head.appendChild(appleTouchIcon);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
document.title = getSiteName(window.location.pathname);
const faviconPath = selectFaviconPath(window.location.hostname);
applyFavicon(faviconPath);
root.render(
  <StoreProvider>
    <App />
  </StoreProvider>
);
